import React from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";

const TermsCondition = () => {
  return (
    <div className="min-h-screen bg-white">
      <Header />

      <main className="max-w-2xl mx-auto px-4 py-12">
        <h1 className="text-2xl font-bold text-gray-900 mb-2 text-center">
          Terms & Conditions
        </h1>
        <p className="text-sm text-gray-600 mb-12 text-center leading-relaxed">
          These terms govern registration and participation in Aqua India 2026
          conducted by Society of Aquaculture Professionals (SAP).
        </p>

        <div className="space-y-8">
          <section>
            <h2 className="text-lg font-semibold text-gray-900 mb-4 border-b border-gray-300 pb-1">
              Registration
            </h2>
            <div className="space-y-2 text-sm text-gray-700 leading-relaxed">
              <div>
                • Registration must be completed with accurate information
              </div>
              <div>
                • Entry to session halls and event venues is permitted only with
                valid confirmation credentials
              </div>
            </div>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-gray-900 mb-4 border-b border-gray-300 pb-1">
              Payment
            </h2>
            <div className="space-y-2 text-sm text-gray-700 leading-relaxed">
              <div>• Registration is valid only after full payment</div>
              <div>• As per official Refund Policy: No refunds once paid</div>
            </div>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-gray-900 mb-4 border-b border-gray-300 pb-1">
              Conduct & Safety
            </h2>
            <div className="space-y-2 text-sm text-gray-700 leading-relaxed">
              <div>• Maintain professional behavior</div>
              <div>
                • Follow venue rules, safety guidelines, and instructions from
                event staff
              </div>
              <div>
                • SAP reserves the right to deny access for disciplinary reasons
                without compensation
              </div>
            </div>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-gray-900 mb-4 border-b border-gray-300 pb-1">
              Event Modifications
            </h2>
            <p className="text-sm text-gray-700 leading-relaxed">
              Event agenda, speakers, sessions, or venue may be changed due to
              operational or unforeseen conditions.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-gray-900 mb-4 border-b border-gray-300 pb-1">
              Liability
            </h2>
            <div className="space-y-2 text-sm text-gray-700 leading-relaxed">
              <div>
                • SAP is not liable for travel delays, accommodation issues, or
                any personal belongings lost
              </div>
              <div>• Medical issues or force-majeure events</div>
            </div>
          </section>
        </div>

        <div className="mt-16 pt-8 border-t border-gray-200 text-center">
          <p className="text-sm font-medium text-gray-900 leading-relaxed">
            By completing registration, you agree to these Terms & Conditions.
          </p>
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default TermsCondition;
